exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable.seats td[data-v-09664cd2] {\n    width: 40px;\n    height: 40px;\n    cursor: pointer;\n}\n@media (max-width: 1499px) {\ntable.seats td[data-v-09664cd2] {\n        width: 25px;\n        height: 25px;\n}\n}\n.selected[data-v-09664cd2]{\n    border: 2px solid gray;\n}\n", ""]);

// exports
